import { useEffect, useRef } from "react";
import "./index.scss";
const DotPulse = ({
  width,
  height,
  color = "#5D63C5",
  className,
}: {
  width: number;
  height: number;
  color?: string;
  className?: string;
}) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    !!ref.current && ref.current.style.setProperty("--dotColor", color);
  }, [color]);
  return (
    <div
      ref={ref}
      className={className}
      style={{ transform: `scale(${width},${height})` }}
    >
      <div className="dot-pulse"></div>
    </div>
  );
};

export default DotPulse;
